import { createSlice } from "@reduxjs/toolkit";
import { fetchCourseCategories } from "./courseCategory.thunk";

const initialState = {
  courseCategories: [],
  loading: false,
  error: null,
};

const courseCategorySlice = createSlice({
  name: "courseCategory",

  initialState,

  reducers: {
    clearCourseCategories: (state) => {
      state.courseCategories = [];
    },
  },

  extraReducers: (builder) => {
    builder

      /* ============================================================
         FETCH COURSE CATEGORIES
      ============================================================ */

      .addCase(fetchCourseCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchCourseCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.courseCategories = action.payload.data || [];
      })

      .addCase(fetchCourseCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearCourseCategories,
} = courseCategorySlice.actions;

export default courseCategorySlice.reducer;